import React from "react";
import { motion } from "framer-motion";

import underImg from "../images/under_construction.png"; // ganti nama sesuai file abang

const UnderConstruction = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-400 text-white px-4 text-center">

      {/* Title */}
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-3xl md:text-4xl font-extrabold text-yellow-300 drop-shadow-md mb-8"
      >
        This Page is Under Construction 🚧
      </motion.h1>

      {/* Image */}
      <motion.img
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.7 }}
        src={underImg}
        alt="Under Construction"
        className="w-72 md:w-96 rounded-xl shadow-xl border-4 border-blue-400"
      />

      {/* Description */}
      <p className="text-blue-200 mt-6 text-lg">
        Sorry… this feature is not available yet.
      </p>

      {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default UnderConstruction;
